var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAtt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1909_11796)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1909_11796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6035 57.6729C20.6897 61.6101 27.0737 63.9756 33.9999 63.9756C41.5797 63.9756 48.4895 61.1616 53.7632 56.5421C53.8272 56.4857 53.7956 56.4483 53.7326 56.4857C51.3662 58.0662 44.6215 61.516 34.0002 61.516C24.77 61.516 18.9368 59.4565 15.6426 57.6179C15.5795 57.5868 15.5562 57.6341 15.6035 57.6729ZM36.0363 59.2057C43.4188 59.2057 51.5313 57.1933 56.3833 53.2096C57.711 52.1241 58.9757 50.6796 60.1084 48.7381C60.7605 47.621 61.3982 46.2939 61.9178 44.9893C61.9409 44.9257 61.9015 44.8946 61.8537 44.9661C57.3417 51.606 44.2759 55.7476 30.785 55.7476C21.2488 55.7476 10.9885 52.6981 6.97134 46.8755C6.93175 46.8217 6.89224 46.8448 6.91638 46.9066C10.6586 54.8607 22.0115 59.2057 36.0363 59.2057ZM27.9702 46.0106C12.6158 46.0106 5.37594 38.8595 4.06276 33.9794C4.04649 33.9087 4 33.9242 4 33.9876C4 35.6304 4.16435 37.7506 4.44747 39.1578C4.58236 39.843 5.13983 40.9179 5.95718 41.7747C9.67524 45.6501 18.9445 51.0804 34.9977 51.0804C56.8695 51.0804 61.8703 43.7949 62.8915 41.3988C63.6217 39.6852 64 36.5888 64 33.9875C64 33.358 63.9842 32.8553 63.9604 32.3617C63.9604 32.2817 63.914 32.2751 63.898 32.3532C62.8052 38.2161 44.1184 46.0106 27.9702 46.0106ZM6.89217 21.1229C6.01251 22.8689 5.03718 25.8146 4.74724 27.3392C4.62015 27.9924 4.67429 28.3062 4.90335 28.7935C6.74371 32.6981 16.0524 38.9455 37.7658 38.9455C51.0127 38.9455 61.3031 35.6912 62.9702 29.7524C63.2773 28.6591 63.2936 27.5048 62.8992 25.9494C62.4587 24.2113 61.6334 22.1847 60.9349 20.7615C60.9118 20.715 60.8712 20.722 60.8795 20.7769C61.139 28.5662 39.4169 33.5863 28.4569 33.5863C16.5853 33.5863 6.68102 28.8564 6.68102 22.884C6.68102 22.3102 6.79987 21.7361 6.9481 21.1389C6.96295 21.084 6.91616 21.075 6.89217 21.1229ZM53.8118 11.5592C53.9379 11.7567 54.0007 11.9675 54.0007 12.2514C54.0007 15.5833 43.8032 21.4777 27.57 21.4777C15.6425 21.4777 13.4095 17.0529 13.4095 14.2389C13.4095 13.2331 13.7953 12.2038 14.6449 11.1585C14.6913 11.0964 14.6519 11.0725 14.5983 11.1186C13.0488 12.4318 11.6251 13.9094 10.3761 15.5043C9.77938 16.2587 9.40899 16.927 9.40899 17.3273C9.40899 23.1586 24.0311 27.3868 37.7031 27.3868C52.2709 27.3868 58.7725 22.6312 58.7725 18.4518C58.7725 16.9581 58.1911 16.0862 56.7038 14.3958C55.7383 13.296 54.8251 12.4006 53.8585 11.5192C53.8118 11.4808 53.7792 11.5122 53.8118 11.5592ZM49.3457 8.22799C44.8496 5.53317 39.6288 4 34.0002 4C28.3323 4 22.9541 5.58678 18.442 8.35298C17.0884 9.18592 16.3268 9.85331 16.3268 10.7115C16.3268 13.2409 22.2381 15.9606 32.7257 15.9606C43.1043 15.9606 51.1542 12.9817 51.1542 10.1141C51.1544 9.42976 50.5562 8.95086 49.3457 8.22799Z",
    fill: "#F4F4F4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1909_11796",
    x: -76,
    y: -76,
    width: 220,
    height: 219.976,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0470588 0 0 0 0 0.0784314 0 0 0 0 0.192157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1909_11796"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1909_11796",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1909_11796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAtt);
export default __webpack_public_path__ + "static/media/icon-att.dd586116c1e2299a489a105442750f7e.svg";
export { ForwardRef as ReactComponent };